export abstract class BaseModal {
    protected $element: JQuery;
    protected $content: JQuery;
    protected $body: JQuery;
    protected $header: JQuery;
    protected $footer?: JQuery;

    private isClosable: boolean;
    private hasFooter: boolean;

    constructor(title?: string, size?: string, closable?: boolean, hasFooter?: boolean) {
        this.isClosable = closable === undefined || closable === true ? true : false;
        this.hasFooter = hasFooter === undefined || hasFooter === true ? true : false;

        this.$element = $('<div class="modal fade" role="dialog" aria-hidden="true" />');

        const doc = $(
            '<div class="modal-dialog modal-dialog-centered ' +
                (size !== undefined ? size : "") +
                ' " role="document" />'
        ).appendTo(this.$element);
        this.$content = $('<div class="modal-content" />').appendTo(doc);

        this.$header = $('<div class="modal-header" />');

        this.$header.append('<h5 class="modal-title" >' + (title === undefined ? "" : title) + "</h5>");

        if (this.isClosable)
            this.$header.append(
                '<button type="button" class="close" data-dismiss="modal" aria-label="' + "TEST" + '"></button></div>'
            );

        this.$content.append(this.$header);

        this.$body = $('<div class="modal-body" />').appendTo(this.$content);

        if (this.hasFooter) {
            this.$footer = $('<div class="modal-footer" />').appendTo(this.$content);
        }

        this.$element.on("shown.bs.modal", () => {
            this.showEvent();
        });

        this.$element.on("hidden.bs.modal", () => {
            this.hideEvent();
        });
    }

    public setTitle(newTitle: string): BaseModal {
        this.$content.find("> .modal-header > .modal-title").html(newTitle);
        return this;
    }

    public show() {
        if (this["onBeforeShow"] !== undefined) this["onBeforeShow"]();

        this.$element.appendTo($("body"));
        this.$element["modal"]({
            keyboard: this.isClosable,
        });
    }

    public close() {
        this.$element["modal"]("hide");
    }

    private showEvent() {
        if (this["onShow"] !== undefined) this["onShow"]();
    }

    private hideEvent() {
        if (this["onHide"] !== undefined) this["onHide"]();

        this.$element.detach();
    }
}
